module.exports = __webpack_public_path__ + "static/media/canari_egg.d6e5488a.png";